import styled from "styled-components";

export const CheckboxInputContainer = styled.div<{
  gap?: string;
  alignItems?: "center" | "start";
}>`
  display: grid;
  grid-template-columns: auto 1fr;
  position: relative;
  align-items: ${({ alignItems = "center" }) => alignItems};
  gap: ${({ gap = "8px" }) => gap};
`;

export default CheckboxInputContainer;
